import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var Vector2 = /*#__PURE__*/function () {
  function Vector2(x, y) {
    _classCallCheck(this, Vector2);
    this.x = x;
    this.y = y;
  }
  return _createClass(Vector2, [{
    key: "add",
    value: function add(_ref) {
      var thatX = _ref.x,
        thatY = _ref.y;
      var thisX = this.x,
        thisY = this.y;
      return new Vector2(thisX + thatX, thisY + thatY);
    }
  }, {
    key: "sub",
    value: function sub(_ref2) {
      var thatX = _ref2.x,
        thatY = _ref2.y;
      var thisX = this.x,
        thisY = this.y;
      return new Vector2(thisX - thatX, thisY - thatY);
    }
  }, {
    key: "scaled",
    value: function scaled(scalar) {
      var x = this.x,
        y = this.y;
      return new Vector2(x * scalar, y * scalar);
    }
  }, {
    key: "map",
    value: function map(fn) {
      return new Vector2(fn(this.x), fn(this.y));
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Vector2(this.x, this.y);
    }
  }, {
    key: "rounded",
    value: function rounded() {
      return new Vector2(Math.round(this.x), Math.round(this.y));
    }
  }, {
    key: "toString",
    value: function toString() {
      return "[".concat(this.x, ", ").concat(this.y, "]");
    }
  }]);
}();
export var Rectangle = /*#__PURE__*/function () {
  function Rectangle(width, height) {
    _classCallCheck(this, Rectangle);
    this.width = width;
    this.height = height;
  }
  return _createClass(Rectangle, [{
    key: "aspectRatio",
    get: function get() {
      return this.width / this.height;
    }
  }, {
    key: "center",
    get: function get() {
      return new Vector2(this.width / 2, this.height / 2);
    }
  }, {
    key: "scaled",
    value: function scaled(scale) {
      return new Rectangle(this.width * scale, this.height * scale);
    }
  }, {
    key: "resized",
    value: function resized(width, height) {
      return new Rectangle(width, height);
    }
  }, {
    key: "flipped",
    value: function flipped() {
      return new Rectangle(this.height, this.width);
    }

    // Computes the scaling factor that needs to be applied to this
    // Rectangle so that it
    // - is fully visible inside of the containing Rectangle
    // - is the LARGEST possible size
    // - maintains the original aspect ratio (no distortion)
  }, {
    key: "scaleToFit",
    value: function scaleToFit(containing) {
      var widthRatio = containing.width / this.width;
      var heightRatio = containing.height / this.height;
      if (widthRatio <= heightRatio) {
        return widthRatio;
      } else {
        return heightRatio;
      }
    }
  }, {
    key: "scaleToFitLargestSide",
    value: function scaleToFitLargestSide(containing) {
      return this.scaleToFit(containing);
    }

    // Computes the scaling factor that needs to be applied to this
    // Rectangle so that it
    // - is fully visible inside of the containing Rectangle
    // - is the SMALLEST possible size
    // - maintains the original aspect ratio (no distortion)
  }, {
    key: "scaleToFitSmallestSide",
    value: function scaleToFitSmallestSide(containing) {
      var widthRatio = containing.width / this.width;
      var heightRatio = containing.height / this.height;
      if (widthRatio >= heightRatio) {
        return widthRatio;
      } else {
        return heightRatio;
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Rectangle(this.width, this.height);
    }
  }]);
}();
export var Bounds = /*#__PURE__*/function (_Rectangle) {
  function Bounds(x, y, width, height) {
    var _this;
    _classCallCheck(this, Bounds);
    _this = _callSuper(this, Bounds, [width, height]);
    _this.x = x;
    _this.y = y;
    _this.width = width;
    _this.height = height;
    return _this;
  }
  _inherits(Bounds, _Rectangle);
  return _createClass(Bounds, [{
    key: "origin",
    get: function get() {
      return new Vector2(this.x, this.y);
    }
  }, {
    key: "corner",
    get: function get() {
      return new Vector2(this.x + this.width, this.y + this.height);
    }
  }, {
    key: "center",
    get: function get() {
      return new Vector2(this.x + this.width * 0.5, this.y + this.height * 0.5);
    }
  }, {
    key: "rect",
    get: function get() {
      return new Rectangle(this.width, this.height);
    }
  }, {
    key: "left",
    get: function get() {
      return this.x;
    }
  }, {
    key: "top",
    get: function get() {
      return this.y;
    }
  }, {
    key: "right",
    get: function get() {
      return this.x + this.width;
    }
  }, {
    key: "bottom",
    get: function get() {
      return this.y + this.height;
    }
  }, {
    key: "flipped",
    value: function flipped() {
      var rect = this.rect.flipped();
      return new Bounds(this.x, this.y, rect.width, rect.height);
    }
  }, {
    key: "scaled",
    value: function scaled(scale) {
      return new Bounds(this.x * scale, this.y * scale, this.width * scale, this.height * scale);
    }
  }, {
    key: "relativeTo",
    value: function relativeTo(bounds) {
      return new Bounds(this.x - bounds.x, this.y - bounds.y, this.width, this.height);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Bounds(this.x, this.y, this.width, this.height);
    }
  }, {
    key: "map",
    value: function map(fn) {
      return new Bounds(fn(this.x), fn(this.y), fn(this.width), fn(this.height));
    }
  }, {
    key: "hFlipWithin",
    value: function hFlipWithin(containerBounds) {
      var hGap = containerBounds.right - this.right;
      return new Bounds(containerBounds.left + hGap, this.top, this.width, this.height);
    }
  }, {
    key: "vFlipWithin",
    value: function vFlipWithin(containerBounds) {
      var vGap = this.top - containerBounds.top;
      return new Bounds(this.left, containerBounds.bottom - vGap - this.height, this.width, this.height);
    }
  }, {
    key: "rotate90DegWithin",
    value: function rotate90DegWithin(containerBounds) {
      var hGap = containerBounds.right - this.right;
      var vGap = this.top - containerBounds.top;
      return new Bounds(containerBounds.left + vGap, containerBounds.top + hGap, this.height, this.width);
    }
  }, {
    key: "translated",
    value: function translated(xDelta, yDelta) {
      return new Bounds(this.x + xDelta, this.y + yDelta, this.width, this.height);
    }
  }, {
    key: "equals",
    value: function equals(bounds) {
      return this.x === bounds.x && this.y === bounds.y && this.width === bounds.width && this.height === bounds.height;
    }
  }]);
}(Rectangle);
export var Camera = /*#__PURE__*/function () {
  function Camera(viewport, originalImg) {
    _classCallCheck(this, Camera);
    this.viewport = viewport;
    this.originalImg = originalImg;
  }
  return _createClass(Camera, [{
    key: "resizedViewport",
    value: function resizedViewport(newViewport) {
      return new Camera(newViewport, this.originalImg);
    }
  }, {
    key: "scaleToFit",
    get: function get() {
      return this.originalImg.scaleToFitLargestSide(this.viewport);
    }

    // If the image is smaller than or equal to the viewport, it won't be scaled.
    // If the image is larger than the viewport, it will be scaled down to fit.
  }, {
    key: "scaleDownToFit",
    get: function get() {
      return Math.min(1, this.scaleToFit);
    }
  }, {
    key: "fittedImg",
    get: function get() {
      return this.originalImg.scaled(this.scaleDownToFit);
    }
  }, {
    key: "scaledImg",
    value: function scaledImg(newScale) {
      return this.originalImg.scaled(newScale);
    }
  }, {
    key: "scaledOffset",
    value: function scaledOffset(prevOffset, prevScale, newScale) {
      var viewport = this.viewport;
      return prevOffset.add(viewport.center).scaled(newScale / prevScale).sub(viewport.center);
    }
  }]);
}();